import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20theater%20atmosphere%20with%20warm%20golden%20spotlights%20and%20red%20velvet%20curtains%2C%20soft%20dramatic%20lighting%2C%20dark%20moody%20background%20with%20floating%20dust%20particles%20in%20light%20beams%2C%20elegant%20cinema%20aesthetic%2C%20rich%20warm%20amber%20and%20crimson%20tones%2C%20luxurious%20classic%20theater%20style&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="四虎影视 - 海量高清影视资源"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <h1 className="text-4xl md:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
            海量高清影视
            <span className="block text-primary-400">免费在线观看</span>
          </h1>
          <p className="text-base md:text-lg text-background-200/90 max-w-xl mx-auto mb-8 leading-relaxed">
            涵盖最新电影、热门电视剧、综艺节目、动漫资源，无需注册即可免费观看，多终端流畅播放，更新及时
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/movie"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              立即观影
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/category/tv"
              className="px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-base hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              热门剧集
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-10">
            {[
              { value: '10万+', label: '影视资源' },
              { value: '5000万+', label: '月活用户' },
              { value: '4.8', label: '用户评分' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-background-300 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-background-50/40 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-background-50/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}